"use client";
import * as React from "react";
const SvgExternalOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M14.22 8.89v5.33H1.78V1.78H7.1V0H1.78C.8 0 0 .8 0 1.78v12.44C0 15.2.8 16 1.78 16h12.44c.98 0 1.78-.8 1.78-1.78V8.9zm-1.26-7.11H9.71V0h6.28v6.28h-1.77V3.04L8.14 9.12 6.9 7.87z" }));
export {
  SvgExternalOutlined as default
};
